import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';
import metadata from './CondominiumsDetails.metadata.json5';
import messages from './CondominiumsDetails.messages';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import PropertyDetailsComponent from '../subcomponents/PropertyDetails/PropertyDetailsComponent';
import ConstructionComponent from '../subcomponents/Construction/ConstructionComponent';
import OtherComponent from '../subcomponents/Other/OtherComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function CondominiumsDetails(props) {

    const { submissionVM, updateWizardData, pathUpdated, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('CondominiumsDetails');

    const modelVM = _.get(submissionVM, pathUpdated);
    const { showConfirm } = useModal();

    modelVM.value.isValidationReq = true;

    const deleteCondominiumDetails = useCallback(
        () => {
            const infoListPath = 'lobData.perLine.coverables.condoCoverable.condominiums.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        propertyDetailsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.propertyDetails`,
            viewModelService
        },
        constructionComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.construction`,
            basePath: pathUpdated
        },
        otherComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.other`,
            propertyPathUpdated: `${pathUpdated}.propertyDetails`
        },
        condominiumsAccordionDetails: {
            title: _.get(
                modelVM,
                `propertyDetails.accountLocFie.displayName.value`
            )
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deleteCondominiumDetails
        },
        resolveComponentMap: {
            propertyDetailsComponent: PropertyDetailsComponent,
            constructionComponent: ConstructionComponent,
            otherComponent: OtherComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

CondominiumsDetails.propTypes = wizardProps;
export default withRouter(CondominiumsDetails);
